export default "__VITE_ASSET__D12sK8m8__"